// ── apple-native palette ──────────────────────────────────────────
// Same EXPORT NAMES as every other theme (components import these), but
// remapped to an Apple-calm language. Components that reference NAVY/GOLD get
// reskinned for free; the rest is driven by this theme's global.js.
//
//   NAVY  → near-black: dark surfaces (sidebar), headings, dark UI
//   GOLD  → the single accent (Apple blue): CTAs, active states, key data only
export const NAVY   = "#1D1D1F";  // Apple near-black
export const GOLD   = "#0071E3";  // Apple blue — the one accent
export const WHITE  = "#FFFFFF";
export const DANGER = "#D7322B";  // muted red (not bright)

// Extra tokens the redesigned screens can use directly (older screens ignore them).
export const BG      = "#F5F5F7";  // Apple signature off-white background
export const SURFACE = "#FFFFFF";
export const TEXT     = "#1D1D1F";
export const TEXT2    = "#86868B";  // secondary text
export const BORDER   = "#D2D2D7";  // hairline dividers
export const ACCENT       = "#0071E3";
export const ACCENT_HOVER = "#0077ED";
